import { Card, Flex } from '@brightdrop/bd-ui';
import { Link, Switch, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import TranslatedLabel, {
  translateText,
} from '~/common/components/TranslatedLabel/TranslatedLabel';
import useOverviewCardStyles from '~/features/integrations/manage/overview-card.styles';

import useStyles from './CoastSettingsCard.styles';

const TRANSLATION_KEYS = {
  title: 'integrations:coast.settings.title',
  description: 'integrations:coast.settings.description',
  autoEnable: 'integrations:coast.settings.autoEnable',
  autoEnableDescription: 'integrations:coast.settings.autoEnableDescription',
  learnMore: 'integrations:coast.settings.learnMore',
} as const;

/** Coast data-sharing preferences. Read-only: the service has no endpoint for this setting yet. */
const CoastSettingsCard = (): JSX.Element => {
  const { classes } = useStyles();
  const { classes: cardClasses } = useOverviewCardStyles();
  const { t } = useTranslation('integrations');
  // Shares the Shop card's Learn more destination, which is not defined yet.
  const handleLearnMore = () => {};

  return (
    <Card dataTestId="account-integrations-coast-settings">
      <Flex col gap={4}>
        <TranslatedLabel
          translationKey={TRANSLATION_KEYS.title}
          typographyVariant="header2_medium"
          className={cardClasses.title}
          component="h2"
        />
        <TranslatedLabel
          translationKey={TRANSLATION_KEYS.description}
          typographyVariant="small_body_regular"
          className={cardClasses.secondary}
        />
      </Flex>
      <Flex className={classes.settingRow}>
        <Flex col gap={4}>
          <TranslatedLabel
            translationKey={TRANSLATION_KEYS.autoEnable}
            typographyVariant="body_medium"
          />
          <TranslatedLabel
            translationKey={TRANSLATION_KEYS.autoEnableDescription}
            typographyVariant="small_body_regular"
            className={cardClasses.secondary}
          />
        </Flex>
        <Switch
          disabled
          slotProps={{
            input: {
              'aria-label': translateText(TRANSLATION_KEYS.autoEnable),
            },
          }}
          data-testid="account-integrations-coast-auto-enable-toggle"
        />
      </Flex>
      <Typography
        variant="small_body_regular"
        component="p"
        className={classes.learnMore}
        marginTop={1}
      >
        <Trans
          t={t}
          i18nKey={TRANSLATION_KEYS.learnMore}
          components={{
            learnMoreLink: (
              <Link
                component="button"
                type="button"
                onClick={handleLearnMore}
                data-testid="account-integrations-coast-learn-more"
              />
            ),
          }}
        />
      </Typography>
    </Card>
  );
};

export default Object.assign(CoastSettingsCard, {
  sectionId: 'coast-settings',
});
